import { labeled, numberRequired, stringRequired } from '../../util/joi';

export const loanworksSchema = (Joi: any, label: string) =>
  Joi.object().keys({
    years: numberRequired(Joi, 1, 40).label(labeled(label, 'Years')),
    months: numberRequired(Joi, 0, 180).label(labeled(label, 'Months'))
  });

export const assetFinanceSchema = (Joi: any, label: string) =>
  Joi.object().keys({
    months: numberRequired(Joi, 0, 180).label(labeled(label, 'Months')),
    preferredLenders: stringRequired(Joi).label(labeled(label, 'Preferred lenders')),
    notLenders: stringRequired(Joi).label(
      labeled(label, 'Any lenders you do not wish to deal with?')
    )
  });

export const homeLoanSchema = (Joi: any, label: string) =>
  assetFinanceSchema(Joi, label).keys({
    years: numberRequired(Joi, 1, 40).label(labeled(label, 'Years'))
  });

export default {
  loanworksSchema,
  assetFinanceSchema,
  homeLoanSchema
};
